import { Stack, Title } from "@mantine/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { PerformanceChart } from "@/components/elements";
import { useMarketCarValuation } from "@/services/market/get-market-car-valuation";
import { tooltipFormatter } from "@/utils/tooltipFormatter";

import type { DatesRange } from "@/types/entity";
import type { MantineStyleProps } from "@mantine/core";
import type { FC } from "react";

export type CarValuationProps = {
  defaultBenchmark?: string;
  carId?: string;
} & MantineStyleProps;

export const CarValuation: FC<CarValuationProps> = ({ carId, defaultBenchmark, ...props }) => {
  const { t } = useTranslation();
  const [range, setRange] = useState<DatesRange>();
  const { data, isLoading } = useMarketCarValuation({ carId, ...range });

  return (
    <Stack {...props}>
      <Title order={3}>{t("car.valuation")}</Title>
      <PerformanceChart
        {...data}
        defaultBenchmark={defaultBenchmark}
        loading={isLoading}
        onTimeframeChange={setRange}
        tooltipFormatter={tooltipFormatter}
        restrictKpisByPlan
      />
    </Stack>
  );
};
